// eslint-disable-next-line no-shadow
enum NotificationLevelEnum {
  INFO = 'Info',
  DANGER = 'Danger',
  SUCCESS = 'Success',
  WARNING = 'Warning',
}

export default NotificationLevelEnum;
